import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router";
import TopNavigation from "./Navbar";
import Sidebar from "./Sidebar";
import { connect } from "react-redux";

import logoIcon from "../../assets/images/logo.png";

import "./Base.css";
import "./ShellResponsive.css";
import { Paper } from "@material-ui/core";
import { PendingSchedulesProvider } from "../../contexts/PendingSchedulesContext";
import { PendingMachineRegistrationProvider } from "../../contexts/PendingMachineRegistrationContext";
import { PendingOperatorAccessProvider } from "../../contexts/PendingOperatorAccessContext";
import { PendingActionsProvider } from "../../contexts/PendingActionsContext";
import ShellMenuContext, {
  MOBILE_SHELL_MAX_WIDTH,
} from "../../contexts/ShellMenuContext";

function Layout(props) {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = useCallback(() => {
    setMobileMenuOpen(false);
    document.body.classList.remove("mobile-menu-open");
  }, []);

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen((open) => {
      const next = !open;
      document.body.classList.toggle("mobile-menu-open", next);
      return next;
    });
  }, []);

  useEffect(() => {
    const unlisten = props.history.listen(() => {
      closeMobileMenu();
    });
    return unlisten;
  }, [props.history, closeMobileMenu]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > MOBILE_SHELL_MAX_WIDTH) {
        closeMobileMenu();
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closeMobileMenu();
      }
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("keydown", onKeyDown);
      document.body.classList.remove("mobile-menu-open");
    };
  }, [closeMobileMenu]);

  const menuValue = useMemo(
    () => ({
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
    }),
    [mobileMenuOpen, toggleMobileMenu, closeMobileMenu]
  );

  return (
    <ShellMenuContext.Provider value={menuValue}>
      <div className="container body">
        <div className="main_container">
          {props.farm.id !== undefined ? (
            <PendingSchedulesProvider farm_id={props.farm.id}>
              <PendingMachineRegistrationProvider farm_id={props.farm.id}>
                <PendingOperatorAccessProvider farm_id={props.farm.id}>
                  <PendingActionsProvider>
                    <TopNavigation
                      farm_id={props.farm.id}
                      farm_name={
                        props.farm !== undefined
                          ? props.farm.nome_da_fazenda
                          : ""
                      }
                      mobileMenuOpen={mobileMenuOpen}
                      onToggleMobileMenu={toggleMobileMenu}
                    />
                    <Sidebar farm_id={props.farm.id} />
                    {mobileMenuOpen ? (
                      <button
                        type="button"
                        className="shell-drawer-overlay"
                        aria-label={t("Fechar menu")}
                        onClick={closeMobileMenu}
                      />
                    ) : null}
                    <main className="right_col" role="main">
                      <Paper className={`x_panel`} style={{ height: "auto" }}>
                        {props.children}
                      </Paper>
                    </main>
                  </PendingActionsProvider>
                </PendingOperatorAccessProvider>
              </PendingMachineRegistrationProvider>
            </PendingSchedulesProvider>
          ) : (
            <div className="initial-loading">
              <img src={logoIcon} alt="..." className="logo-loading" />
            </div>
          )}
        </div>
      </div>
    </ShellMenuContext.Provider>
  );
}

const mapStateToProps = (store) => ({
  farm: store.current_farm,
});

export default withRouter(connect(mapStateToProps)(Layout));
